import styled from 'styled-components'
import { InputStyledBase } from '@gearedapp/ga-storybook'
import { JustLabelTypes } from '@gearedapp/ga-storybook/dist/components/Label/types'

export default styled.textarea<JustLabelTypes>`
  ${InputStyledBase}
`
